"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackChatGPTPage } from "@/lib/analytics/chatGPTAds";

export default function ChatGPTAdsPixel() {
    const pathname = usePathname();
    useEffect(() => {
        const sync = () => trackChatGPTPage(pathname);
        sync();
        window.addEventListener("tc:measurement-consent", sync);
        window.addEventListener("storage", sync);
        return () => {
            window.removeEventListener("tc:measurement-consent", sync);
            window.removeEventListener("storage", sync);
        };
    }, [pathname]);
    return null;
}
